import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { outcomes } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full bg-green-deep py-12 sm:py-16" aria-labelledby="final-cta-heading" data-id="element-93" data-mp="3qtjemy0see2f">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-94" data-mp="3vscgft6pogmr">
        <p className="eyebrow text-gold-soft" data-id="element-95" data-mp="3vrumj37iuei0">El próximo lunes</p>
        <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-display text-[1.9rem] font-bold leading-[1.1] text-shell sm:text-[2.5rem]" data-id="element-96" data-mp="2y5x1ay1rbv2d">
          Dejá de improvisar. Empezá a enseñar{' '}
          <span className="text-gold-soft" data-id="element-97" data-mp="3820b8q2uoxzv">con sistema</span>.
        </h2>
        <p className="mx-auto mt-5 max-w-readable font-sans text-base leading-relaxed text-shell/80" data-id="element-98" data-mp="3cu9zm1obhq01">
          Miles de docentes argentinos ya planifican su año en menos de 10
          minutos. ¿Cuántas clases más querés improvisar?
        </p>

        <ul className="mx-auto mt-9 grid max-w-2xl gap-x-8 gap-y-3 text-left sm:grid-cols-2" data-id="element-99" data-mp="2kbmisygcsx4r">
          {outcomes.map(outcome => <li key={outcome.text} className={`flex items-start gap-2.5 font-sans text-[0.88rem] leading-relaxed ${outcome.positive ? 'font-semibold text-gold-soft' : 'text-shell/70'}`} data-id="element-100" data-mp="2dduohil5pute">
              {outcome.positive ? <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-soft" strokeWidth={2.6} aria-hidden="true" data-id="element-101" data-mp="1yn3wa9fnktpr" /> : <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-shell/45" strokeWidth={2.6} aria-hidden="true" data-id="element-102" data-mp="1uliov3lw17my" />}
              {outcome.text}
            </li>)}
        </ul>

        <CtaButton size="large" className="mt-10 !bg-gold !text-green-deep hover:!bg-gold-soft" data-id="element-103" data-mp="1pl4evg0q7nma">
          Quiero mi MEGAPACK
        </CtaButton>

        <p className="mt-5 font-sans text-[11px] text-shell/70" data-id="element-104" data-mp="1forl6i56l9rj">
          Mercado Pago · acceso inmediato · garantía de 7 días sin riesgos
        </p>
      </div>
    </section>;
}